export default __webpack_public_path__ + "static/media/score-review-board.990b2d97.png";